export function findKeyByValue(obj, valueToFind) {
  for (const key in obj) {
    if (obj[key] === valueToFind) {
      return key;
    }
  }
  return null;
}